<template>
  <div>
    <v-card>
      <v-card-title class="text-h6 blue darken-4 lighten-2 py-2">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="h6" style="color:white!important;">
              <v-icon color="white">mdi-format-list-numbered</v-icon>
              Secciones y preguntas
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="mx-2 mt-2">
          <v-col class="text-left" cols="12" md="6">
            <dialog-form-seccion :id-accion="1" :id-encuesta-prop="idEncuesta" :fn-on-save="obtenerSeccionesByEncuesta"></dialog-form-seccion>
          </v-col>
          <v-col class="text-right" cols="12" md="6">
            <dialog-ordenar-seccion :lst-secciones="lstSecciones" :fn-on-save="obtenerSeccionesByEncuesta"></dialog-ordenar-seccion>
          </v-col>
        </v-row>

        <v-row class="mx-2 mt-2">
          <v-col v-if="loadingSecciones" class="text-center" cols="12">
            <v-skeleton-loader type="image" />
          </v-col>
          <v-col v-else cols="12">
            <v-alert 
              v-if="lstSecciones.length == 0"
              type="info">
              No se han encontrado secciones para esta encuesta.
            </v-alert>

            <v-stepper v-else vertical non-linear>
              <div v-for="(item, index) in lstSecciones" :key="'div_step_'+index">
                <v-stepper-step :step="index+1" editable style="background:rgba(0, 0, 0, 0.06)">
                  <v-row no-gutters>
                    <v-col cols="12">
                      {{item.nombreSeccion}}
                      <br>
                      <small>{{item.descripcionSeccion}}</small>
                    </v-col>
                  </v-row>                  
                </v-stepper-step>
            
                <v-stepper-content :step="index+1" class="ml-0">
                  <v-row no-gutters class="mb-6">
                    <v-col cols="12" class="text-center" style="display: ruby;">
                      <dialog-form-seccion :id-accion="2" :id-encuesta-prop="idEncuesta" :obj-seccion="item" :fn-on-save="obtenerSeccionesByEncuesta" :button-size-small="true"></dialog-form-seccion>
                      <dialog-eliminar-seccion :id-seccion="item.idSeccion" :obj-seccion="item" :fn-on-save="obtenerSeccionesByEncuesta" :button-size-small="true"></dialog-eliminar-seccion>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <preguntas-seccion-encuesta 
                        :id-encuesta="idEncuesta" 
                        :id-seccion="item.idSeccion"
                        :lst-preguntas="item.eiPregunta"
                        :fn-set-preguntas="setPreguntasSeccion"
                        :fn-set-respuestas="setRespuestasPreguntaSeccion"
                      >
                      </preguntas-seccion-encuesta>
                    </v-col>
                  </v-row>
                  
                </v-stepper-content>
              </div>
            </v-stepper>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import{ getSeccionesByEncuesta } from "@/api";
import PreguntasSeccionEncuesta from './PreguntasSeccionEncuesta.vue';

export default {
  name: "SeccionesEncuesta",
  components: {
    DialogFormSeccion: () =>
      import("../disenarEncuesta/DialogFormSeccion"),
    DialogOrdenarSeccion: () =>
      import("../disenarEncuesta/DialogOrdenarSeccion"),
    DialogEliminarSeccion: () =>
      import("../disenarEncuesta/DialogEliminarSeccion"),
    PreguntasSeccionEncuesta: () =>
      import("../disenarEncuesta/PreguntasSeccionEncuesta"),
  },
  props: {
    idEncuesta: {
      type: Number,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },    
  },
  data () {
    return {
      loadingSecciones: true,
      lstSecciones: [],

    };
  },
  computed: {
  },
  beforeMount () {},
  async mounted () {
    this.obtenerSeccionesByEncuesta();
  },
  methods: {
    async obtenerSeccionesByEncuesta () {

      var self = this;
      self.loadingSecciones = true;
      self.lstSecciones = [];

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getSeccionesByEncuesta(self.idEncuesta, self.token);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.lstSecciones = response.data.data;
            }
          } else {
            self.error = response.data.message;
            self.snackbarTexto = "InicioAdministrarEncuesta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "InicioAdministrarEncuesta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingSecciones = false;
      } catch (e) {
        self.loadingEncuesta = false;
        self.error = e;
        self.snackbarTexto = "InicioAdministrarEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    setPreguntasSeccion(idSeccion, lstPreguntas){
      var objSeccion = this.lstSecciones.filter(n=>n.idSeccion == idSeccion)[0];
      objSeccion.eiPregunta = lstPreguntas;
    },
    setRespuestasPreguntaSeccion(idSeccion, idPregunta, lstRespuestas){
      var objSeccion = this.lstSecciones.filter(n=>n.idSeccion == idSeccion)[0];
      var objPregunta = objSeccion.eiPregunta.filter(n=>n.idPregunta == idPregunta)[0];

      objPregunta.eiCatRespuesta = lstRespuestas;
    }
  }
};
</script>



<style>
.v-stepper__label{
  display: contents!important;
}
</style>